/**
 * This error is thrown when Financial Partners do not integrate according to
 * the 3p ECE spec. Notably this is not part of the exported types shared with
 * the financial partner. This is in line with other exceptions in this
 * category, e.g. `IntegrationError`.
 *
 * An example use case of this is when a Financial Partner does not debounce
 * their button correctly. By spec we need to return a `Promise` to the partner
 * when they call sendClicked. But, we also need to debounce to avoid opening
 * multiple payment sheets. If the partner breaks spec and does not debounce,
 * this error is thrown.
 *
 * Note that these errors need to be explicitly hydrated in stripethirdparty, so
 * this class is intentionally not shared to sjs. If a promise is rejected in
 * sjs, then the corresponding promise in stripethirdparty will never resolve.
 */
export class FinancialPartnerIntegrationError extends Error {
  constructor({message, code}: {message?: string; code?: string}) {
    const fullMessage = code ? `${code}: ${message}` : message;
    super(fullMessage);
    this.name = 'FinancialPartnerIntegrationError';
    Object.setPrototypeOf(this, FinancialPartnerIntegrationError.prototype);
  }
}
